require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-the-root-of-our-culture.json") })
        }
      }, "path---es-articles-the-root-of-our-culture");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-the-root-of-our-culture!./.cache/json/es-articles-the-root-of-our-culture.json
// module id = 2399
// module chunks = 231608221292675